<aside class="main-sidebar sidebar-dark-primary auction-sidebar">
  <!-- Brand Logo -->
  <a routerLink="/" class="brand-link auction-logo-link">
    <img src="{{ env }}assets/img/auction_logo2.svg" alt="Altawkilat-auction" class="brand-image m-0" />
  </a>

  <div class="sidebar auction-sidebar-inner">
    <nav class="auction-nav my-auto">
      <ul class="nav nav-pills nav-sidebar flex-column auction-nav-list py-3" data-widget="treeview">
        <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
          <a
            class="nav-link auction-nav-link"
            routerLink="/dashboard"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="icon icon-lg mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.563 14.563">
                <path
                  class="a"
                  d="M7.1,2H3.456A1.458,1.458,0,0,0,2,3.456v5.1a1.458,1.458,0,0,0,1.456,1.456H7.1A1.458,1.458,0,0,0,8.553,8.553v-5.1A1.458,1.458,0,0,0,7.1,2Zm8.009,0H11.466a1.458,1.458,0,0,0-1.456,1.456V5.641A1.458,1.458,0,0,0,11.466,7.1h3.641a1.458,1.458,0,0,0,1.456-1.456V3.456A1.458,1.458,0,0,0,15.106,2ZM7.1,11.466H3.456A1.458,1.458,0,0,0,2,12.922v2.184a1.458,1.458,0,0,0,1.456,1.456H7.1a1.458,1.458,0,0,0,1.456-1.456V12.922A1.458,1.458,0,0,0,7.1,11.466Zm8.009-2.913H11.466a1.458,1.458,0,0,0-1.456,1.456v5.1a1.458,1.458,0,0,0,1.456,1.456h3.641a1.458,1.458,0,0,0,1.456-1.456v-5.1A1.458,1.458,0,0,0,15.106,8.553Z"
                  transform="translate(-2 -2)"
                />
              </svg>
            </span>
            <p>Dashboard</p>
          </a>
        </li>
        <li
          class="nav-item auction-nav-item"
          *ngIf="['Super Admin', 'Logistic Admin', 'Auction controller', 'Management', 'Media Admin'].includes(role)"
        >
          <a href="javascript:void(0)" class="nav-link auction-nav-link" (click)="isInventoryCollapse = !isInventoryCollapse">
            <span class="icon icon-lg mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
                <path
                  class="a"
                  d="M5.488,3a.9.9,0,0,0-.781.449L3.124,6.163A.908.908,0,0,0,3,6.619V17.476a1.811,1.811,0,0,0,1.81,1.81h6.6a6.24,6.24,0,0,1-.2-.9h.005a6.285,6.285,0,0,1,7.166-7.166V11.21a6.489,6.489,0,0,1,.9.2V6.619a.908.908,0,0,0-.124-.456L17.579,3.449A.9.9,0,0,0,16.8,3Zm.52,1.81h10.27l1.055,1.81H4.953ZM8.429,8.429h5.429v1.81H8.429Zm9.048,4.524A4.524,4.524,0,1,0,22,17.476,4.524,4.524,0,0,0,17.476,12.952Zm1.855,2.4L20.6,16.617,17.024,20.19l-2.668-2.668,1.265-1.267,1.4,1.4Z"
                  transform="translate(-3 -3)"
                />
              </svg>
            </span>
            <p>Inventory</p>
            <ion-icon
              [name]="isInventoryCollapse ? 'caret-up-outline' : 'caret-down-outline'"
              class="treeview-caret ion-lg ml-auto"
            >
            </ion-icon>
          </a>
          <ul class="nav nav-treeview" [collapse]="!isInventoryCollapse" [isAnimated]="true">
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/inventory"
                [queryParams]="{ type: 'vehicle', page: 1, limit: 10 }"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Auction</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/inventory/retail"
                [queryParams]="{ type: 'available' }"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Retail</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/inventory/new"
                routerLinkActive="active"
                [queryParams]="{ type: 'available' }"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>New</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/inventory/purchase"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Retail Purchase Request</span>
              </a>
            </li>
          </ul>
        </li>

        <li
          class="nav-item auction-nav-item"
          *ngIf="['Super Admin', 'Sales Admin', 'Auction controller', 'Marketing Admin', 'Management'].includes(role)"
        >
          <a
            class="nav-link auction-nav-link"
            routerLink="/dashboard/auction"
            [queryParams]="{ type: 'individual' }"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="icon icon-lg mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
                <path
                  class="a"
                  d="M11.477,1.99a.95.95,0,0,0-.653.287l-.514.514L6.59,6.512l-.514.514A.95.95,0,1,0,7.389,8.4a15.53,15.53,0,0,0,2.333,3.527L2.278,19.369a.95.95,0,1,0,1.343,1.343l7.444-7.444A15.532,15.532,0,0,0,14.592,15.6a.95.95,0,0,0,1.372,1.311l.514-.514.436-.436L20.2,12.68l.514-.514A.95.95,0,0,0,19.4,10.794a15.1,15.1,0,0,0-7.2-7.2.95.95,0,0,0-.72-1.6ZM12.96,6.231a12.651,12.651,0,0,1,3.8,3.8l-2.93,2.93a12.651,12.651,0,0,1-3.8-3.8Z"
                  transform="translate(-2 -1.99)"
                />
              </svg>
            </span>
            <p>Auctions</p>
          </a>
        </li>

        <!-- New auction menu -->
        <li
          class="nav-item auction-nav-item"
          *ngIf="['Super Admin', 'Logistic Admin', 'Auction controller', 'Management', 'Media Admin'].includes(role)"
        >
          <a href="javascript:void(0)" class="nav-link auction-nav-link" (click)="isAuctionsCollapse = !isAuctionsCollapse">
            <span class="icon icon-lg mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
                <path
                  class="a"
                  d="M11.477,1.99a.95.95,0,0,0-.653.287l-.514.514L6.59,6.512l-.514.514A.95.95,0,1,0,7.389,8.4a15.53,15.53,0,0,0,2.333,3.527L2.278,19.369a.95.95,0,1,0,1.343,1.343l7.444-7.444A15.532,15.532,0,0,0,14.592,15.6a.95.95,0,0,0,1.372,1.311l.514-.514.436-.436L20.2,12.68l.514-.514A.95.95,0,0,0,19.4,10.794a15.1,15.1,0,0,0-7.2-7.2.95.95,0,0,0-.72-1.6ZM12.96,6.231a12.651,12.651,0,0,1,3.8,3.8l-2.93,2.93a12.651,12.651,0,0,1-3.8-3.8Z"
                  transform="translate(-2 -1.99)"
                />
              </svg>
            </span>
            <p>Auctions2</p>
            <ion-icon
              [name]="isAuctionsCollapse ? 'caret-up-outline' : 'caret-down-outline'"
              class="treeview-caret ion-lg ml-auto"
            ></ion-icon>
          </a>
          <ul class="nav nav-treeview" [collapse]="!isAuctionsCollapse" [isAnimated]="true">
            <li class="nav-item">
              <a class="nav-link" routerLink="auction/create" [queryParams]="{ type: 'bulk' }" routerLinkActive="active">
                <i class="las la-circle nav-icon"></i>
                <span>Create</span>
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link" routerLink="auction/instant" [queryParams]="{ page: 1, limit: 10 }" routerLinkActive="active">
                <i class="las la-circle nav-icon"></i>
                <span>Instant</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="auction/individual"
                [queryParams]="{ page: 1, limit: 10 }"
                routerLinkActive="active"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Individual</span>
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link" routerLink="auction/bulk" [queryParams]="{ page: 1, limit: 10 }" routerLinkActive="active">
                <i class="las la-circle nav-icon"></i>
                <span>Bulk</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="auction/timed-individual"
                [queryParams]="{ tab: 'inventory', page: 1, limit: 10 }"
                routerLinkActive="active"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Timed-Individual</span>
              </a>
            </li>

            <li class="nav-item">
              <a class="nav-link" routerLink="auction/batch" routerLinkActive="active">
                <i class="las la-circle nav-icon"></i>
                <span>Batch</span>
              </a>
            </li>
          </ul>
        </li>

        <li
          class="nav-item auction-nav-item"
          *ngIf="['Super Admin', 'Logistic Admin', 'Auction controller', 'Management', 'Media Admin'].includes(role)"
        >
          <a href="javascript:void(0)" class="nav-link auction-nav-link" (click)="isBuyersCollapse = !isBuyersCollapse">
            <span class="icon icon-lg mr-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="512"
                height="512"
                x="0"
                y="0"
                viewBox="0 0 512 512"
                style="enable-background: new 0 0 512 512"
                xml:space="preserve"
                class=""
              >
                <g>
                  <path
                    fill-rule="evenodd"
                    d="m336.086 397.381 3.7-126.884a73.462 73.462 0 0 0-34.212-5.89c-30.435 25.656-61.645 38.091-92.764 36.948-31.11 1.133-62.31-11.292-92.758-36.955-32.293-2.076-55.052 16.24-68.567 32.259C33.159 318.544 20.593 349.131 17 380.78c-5.268 46.433 9.343 103.269 67.794 111.059h9.423v-90.64a9.19 9.19 0 0 1 18.379 0v90.64h200.456V401.2a9.189 9.189 0 0 1 18.377 0v90.64h9.425c45.125-6.013 60.654-39.572 65.921-64.412h-41.5a29.189 29.189 0 0 1-29.188-30.047zm63.1-175.471a24.2 24.2 0 1 1 48.392 0v37.673H399.19V221.91zm66.771 37.673h11.75a10.825 10.825 0 0 1 10.8 10.19l7.471 127.827a10.828 10.828 0 0 1-10.8 11.456h-119.9a10.828 10.828 0 0 1-10.824-11.138l3.738-127.823A10.767 10.767 0 0 1 369 259.583h11.813V221.91a42.574 42.574 0 0 1 85.148 0v37.673zM282.2 187.658a98.125 98.125 0 1 0-69.385 28.742 98.226 98.226 0 0 0 69.385-28.742z"
                    fill="#ffffff"
                    opacity="1"
                    data-original="#000000"
                    class=""
                  ></path>
                </g>
              </svg>
            </span>
            <p>Buyers</p>
            <ion-icon [name]="isBuyersCollapse ? 'caret-up-outline' : 'caret-down-outline'" class="treeview-caret ion-lg ml-auto">
            </ion-icon>
          </a>
          <ul class="nav nav-treeview" [collapse]="!isBuyersCollapse" [isAnimated]="true">
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="buyers/auction"
                [queryParams]="{ tab: 'bulk', page: 1, limit: 10 }"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Auction</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="buyers/retail"
                [queryParams]="{ page: 1, limit: 10 }"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Retail</span>
              </a>
            </li>
          </ul>
        </li>

        <li
          class="nav-item auction-nav-item"
          *ngIf="['Super Admin', 'Sales Admin', 'Auction controller', 'Marketing Admin', 'Management'].includes(role)"
        >
          <a
            class="nav-link auction-nav-link"
            routerLink="/dashboard/calendar"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="icon icon-lg mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.98 19.978">
                <path
                  class="a"
                  d="M6,1V3H5A2,2,0,0,0,3,5V18.98a2,2,0,0,0,2,2H18.982a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2h-1V1h-2V3H7.994V1ZM5,7.992H18.982V18.98H5Z"
                  transform="translate(-3 -1)"
                />
              </svg>
            </span>
            <p>Calendar</p>
          </a>
        </li>
        <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
          <a class="nav-link auction-nav-link" href="javascript:void(0)" (click)="isUserCollapse = !isUserCollapse">
            <span class="icon icon-lg mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
                <path
                  class="a"
                  d="M12,3a4,4,0,1,0,4,4,4,4,0,0,0-4-4Zm0,11c-3,0-9,1.508-9,4.5V20a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V18.5C21,15.508,15,14,12,14Z"
                  transform="translate(-3 -3)"
                />
              </svg>
            </span>
            <p>User</p>
            <ion-icon [name]="isUserCollapse ? 'caret-up-outline' : 'caret-down-outline'" class="treeview-caret ion-lg ml-auto">
            </ion-icon>
          </a>

          <!-- start -->
          <ul class="nav nav-treeview" [collapse]="!isUserCollapse" [isAnimated]="true">
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/user"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>User</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/user/pdi"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>PDI</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/user/add-user"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Add User</span>
              </a>
            </li>
          </ul>
        </li>

        <li
          class="nav-item auction-nav-item"
          *ngIf="
            [
              'Super Admin',
              'Sales Admin',
              'Auction controller',
              'Accounts Admin',
              'Accounts Manager',
              'Marketing Admin',
              'Management'
            ].includes(role)
          "
        >
          <a href="javascript:void(0)" class="nav-link auction-nav-link" (click)="isCollapse = !isCollapse">
            <span class="icon icon-lg mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.98 19.98">
                <path
                  class="a"
                  d="M11.414,2a.5.5,0,0,0-.494.418l-.283,1.7a7.9,7.9,0,0,0-1.409.38l-1.1-1.335a.5.5,0,0,0-.636-.115l-1,.576a.5.5,0,0,0-.219.607l.6,1.616A8.084,8.084,0,0,0,5.85,6.884l-1.616-.6a.5.5,0,0,0-.607.219l-.576,1a.5.5,0,0,0,.115.636L4.5,9.229a7.9,7.9,0,0,0-.38,1.409l-1.7.283A.5.5,0,0,0,2,11.414v1.151a.5.5,0,0,0,.418.494l1.7.283a7.9,7.9,0,0,0,.38,1.409l-1.335,1.1a.5.5,0,0,0-.115.636l.576,1a.5.5,0,0,0,.607.219l1.616-.6A8.084,8.084,0,0,0,6.884,18.13l-.6,1.616a.5.5,0,0,0,.219.607l1,.576a.5.5,0,0,0,.636-.115l1.1-1.335a7.9,7.9,0,0,0,1.411.38l.283,1.7a.5.5,0,0,0,.494.418h1.151a.5.5,0,0,0,.494-.418l.283-1.7a7.9,7.9,0,0,0,1.409-.38l1.1,1.335a.5.5,0,0,0,.636.115l1-.576a.5.5,0,0,0,.219-.607l-.6-1.616A8.083,8.083,0,0,0,18.13,17.1l1.616.6a.5.5,0,0,0,.607-.219l.576-1a.5.5,0,0,0-.115-.636l-1.335-1.1a7.9,7.9,0,0,0,.38-1.411l1.7-.283a.5.5,0,0,0,.418-.494V11.414a.5.5,0,0,0-.418-.494l-1.7-.283a7.9,7.9,0,0,0-.38-1.409l1.335-1.1a.5.5,0,0,0,.115-.636l-.576-1a.5.5,0,0,0-.607-.219l-1.616.6A8.084,8.084,0,0,0,17.1,5.85l.6-1.616a.5.5,0,0,0-.219-.607l-1-.576a.5.5,0,0,0-.636.115L14.753,4.5a7.9,7.9,0,0,0-1.411-.38l-.283-1.7A.5.5,0,0,0,12.566,2Zm-.423,4.086V9.167a2.993,2.993,0,0,0-1.947,3.372L6.375,14.078a5.98,5.98,0,0,1,4.616-7.992Zm2,0A5.977,5.977,0,0,1,17.6,14.08l-2.669-1.543a2.975,2.975,0,0,0-1.945-3.368Zm.946,8.179,2.679,1.547a6.009,6.009,0,0,1-9.249,0l2.677-1.545a2.988,2.988,0,0,0,3.893,0Z"
                  transform="translate(-2 -2)"
                />
              </svg>
            </span>
            <p>Settings</p>
            <ion-icon [name]="isCollapse ? 'caret-up-outline' : 'caret-down-outline'" class="treeview-caret ion-lg ml-auto">
            </ion-icon>
          </a>

          <ul class="nav nav-treeview" [collapse]="!isCollapse" [isAnimated]="true">
            <li class="nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
              <a
                class="nav-link"
                routerLink="/dashboard/settings/email-templates"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Email templates</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
              <a
                class="nav-link"
                routerLink="/dashboard/settings/sms-templates"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>SMS template</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
              <a
                class="nav-link"
                routerLink="/dashboard/settings/api-management"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>API key management</span>
              </a>
            </li>
            <li
              class="nav-item"
              *ngIf="
                [
                  'Super Admin',
                  'Sales Admin',
                  'Auction controller',
                  'Accounts Admin',
                  'Accounts Manager',
                  'Marketing Admin',
                  'Management'
                ].includes(role)
              "
            >
              <a
                class="nav-link"
                routerLink="/dashboard/settings/system"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>System Settings</span>
              </a>
            </li>
            <li class="nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
              <a
                routerLink="/dashboard/settings/user-roles"
                class="nav-link"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>User roles</span>
              </a>
            </li>
            <!-- <li class="nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
              <a routerLink="/" class="nav-link">
                <i class="las la-circle nav-icon"></i>
                <span>Categories</span>
              </a>
            </li> -->
          </ul>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
          <a href="javascript:void(0)" class="nav-link auction-nav-link" (click)="isCMSCollapse = !isCMSCollapse">
            <span class="icon icon-lg mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.458 14.766">
                <path
                  class="a"
                  d="M4.686,4A1.769,1.769,0,0,0,2.923,5.763v7.549a1.769,1.769,0,0,0,1.763,1.763H17.772a1.769,1.769,0,0,0,1.763-1.763V5.763A1.769,1.769,0,0,0,17.772,4ZM6.615,6.769h9.229V8.615H6.615Zm0,3.692h6.46v1.846H6.615ZM2,16.921v1.846H20.458V16.921Z"
                  transform="translate(-2 -4)"
                />
              </svg>
            </span>
            <p>CMS pages</p>
            <ion-icon [name]="isCMSCollapse ? 'caret-up-outline' : 'caret-down-outline'" class="treeview-caret ion-lg ml-auto">
            </ion-icon>
          </a>
          <ul class="nav nav-treeview" [collapse]="!isCMSCollapse" [isAnimated]="true">
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/cms"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Home</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/cms/common"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Common</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/cms/review"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Review</span>
              </a>
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/cms/services"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Services</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/cms/finance"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Finance</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/cms/sell"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Sell</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/cms/trade"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Trade</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/cms/auction"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Auction</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/cms/faq"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>FAQ</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/cms/email"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Email</span>
              </a>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                routerLink="/dashboard/cms/buy"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
              >
                <i class="las la-circle nav-icon"></i>
                <span>Buy</span>
              </a>
            </li>
          </ul>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
          <a
            routerLink="/dashboard/customer-request"
            class="nav-link auction-nav-link"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="icon icon-lg mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20">
                <path
                  class="a"
                  d="M6,2A2.006,2.006,0,0,0,4,4V20a2.006,2.006,0,0,0,2,2H18a2.006,2.006,0,0,0,2-2V4a2,2,0,0,0-2-2ZM7,5H17V7H7Zm3.453,6.012a2.267,2.267,0,0,1,1.627.691A3.435,3.435,0,0,1,13,14.02a4.511,4.511,0,0,1-1.33,2.813.9.9,0,0,0,.455.168c.384,0,.642-.271,1.1-.844A2.35,2.35,0,0,1,15,15a1,1,0,0,1,.961.721c.12.4.55,1.279,1.039,1.279v2a2.857,2.857,0,0,1-2.352-1.426A3.2,3.2,0,0,1,12.125,19a3.227,3.227,0,0,1-2.051-.885A6.092,6.092,0,0,1,7,19V17a3.964,3.964,0,0,0,1.787-.467A5.546,5.546,0,0,1,8,14.035a3.319,3.319,0,0,1,.848-2.344A2.223,2.223,0,0,1,10.453,11.012Zm0,1.988a.208.208,0,0,0-.17.082,1.357,1.357,0,0,0-.289.883,3.267,3.267,0,0,0,.375,1.318A2.3,2.3,0,0,0,11,13.98a1.451,1.451,0,0,0-.348-.877C10.55,13,10.487,13,10.457,13Z"
                  transform="translate(-4 -2)"
                />
              </svg>
            </span>
            <p>Contacts</p>
          </a>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Management'].includes(role)">
          <a
            class="nav-link auction-nav-link"
            routerLink="/dashboard/comments"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            <span class="icon icon-lg mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.53 17.53">
                <path
                  class="a"
                  d="M2,4.753V15.271a1.758,1.758,0,0,0,1.753,1.753H16.024L19.53,20.53,19.521,4.753A1.751,1.751,0,0,0,17.777,3H3.753A1.758,1.758,0,0,0,2,4.753Zm4.382.876h8.765V7.382H6.382Zm0,3.506h8.765v1.753H6.382Zm0,3.506h6.135v1.753H6.382Z"
                  transform="translate(-2 -3)"
                />
              </svg>
            </span>
            <p>Reviews</p>
          </a>
        </li>

        <li class="nav-item auction-nav-item" *ngIf="['Super Admin', 'Operation Admin', 'Management'].includes(role)">
          <a
            routerLink="/dashboard/reports"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            class="nav-link auction-nav-link"
          >
            <span class="icon icon-lg mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.707 17">
                <path
                  class="a"
                  d="M4,3V18a2.015,2.015,0,0,0,2,2H21V18H6V3ZM20.293,5.293,16,9.586l-3-3L7.293,12.293l1.414,1.414L13,9.414l3,3,5.707-5.707Z"
                  transform="translate(-4 -3)"
                />
              </svg>
            </span>
            <p>Auction Purchase Request</p>
          </a>
        </li>
      </ul>
    </nav>
  </div>
</aside>
